// src/pages/SAMS.js
// import React, { useEffect, useState, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';
// import imagesLoaded from 'imagesloaded';
// import './OneStepMedi.css';

// const API_URL = 'https://api.securxperts.com:8000';
// const ENDPOINT = '/forms/sams';

// /* -------------------- CONTACT FORM ----------------------- */
// const ContactForm = () => {
//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     country_code: '',
//     phoneno: '',
//     location: '',
//     no_of_branches: '',
//     industry_type: '',
//     no_of_people: '',
//   });

//   const [submitting, setSubmitting] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleChange = (e) =>
//     setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

//   const validate = () => {
//     if (!form.name.trim()) return 'Name is required';
//     if (!form.email.trim()) return 'Email is required';
//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return 'Enter a valid email';
//     if (!form.country_code.trim()) return 'Country code is required';
//     if (!form.phoneno.trim()) return 'Phone number is required';
//     if (!form.location.trim()) return 'Location is required';
//     if (!form.no_of_branches.trim()) return 'Number of branches is required';
//     if (!form.industry_type.trim()) return 'Industry type is required';
//     if (!form.no_of_people.trim()) return 'Number of people is required';
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);

//     const err = validate();
//     if (err) {
//       setStatus({ type: 'error', msg: err });
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const payload = { ...form };

//       const resp = await fetch(`${API_URL}${ENDPOINT}`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });

//       if (resp.ok) {
//         let data = null;
//         try {
//           data = await resp.json();
//         } catch {
//           // ignore parse errors
//         }
//         setStatus({
//           type: 'success',
//           msg: data?.message || 'Thank you! Your request has been submitted.',
//         });
//         setForm({
//           name: '',
//           email: '',
//           country_code: '',
//           phoneno: '',
//           location: '',
//           no_of_branches: '',
//           industry_type: '',
//           no_of_people: '',
//         });
//       } else {
//         let errText = `Server responded with ${resp.status}`;
//         try {
//           const json = await resp.json();
//           if (json?.error) errText = json.error;
//           else if (json?.message) errText = json.message;
//         } catch {
//           const txt = await resp.text().catch(() => null);
//           if (txt) errText = txt;
//         }
//         setStatus({ type: 'error', msg: `Submission failed: ${errText}` });
//       }
//     } catch (error) {
//       console.error('SAMS submit error:', error);
//       setStatus({ type: 'error', msg: 'Network error. Please try again.' });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="max-w-3xl mx-auto bg-white/5 p-6 md:p-10 rounded-2xl shadow-lg"
//       aria-label="School Administration Software Enquiry Form"
//     >
//       <h3 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
//         School Administration Software – Enquiry Form
//       </h3>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         <input
//           name="name"
//           value={form.name}
//           onChange={handleChange}
//           placeholder="Full Name"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="email"
//           type="email"
//           value={form.email}
//           onChange={handleChange}
//           placeholder="Email"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="country_code"
//           value={form.country_code}
//           onChange={handleChange}
//           placeholder="Country Code (e.g. +91)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="phoneno"
//           value={form.phoneno}
//           onChange={handleChange}
//           placeholder="Phone Number"
//           type="tel"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />

//         <input
//           name="location"
//           value={form.location}
//           onChange={handleChange}
//           placeholder="School Location (City, Country)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <input
//           name="no_of_branches"
//           value={form.no_of_branches}
//           onChange={handleChange}
//           placeholder="No. of Branches / Campuses"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <input
//           name="industry_type"
//           value={form.industry_type}
//           onChange={handleChange}
//           placeholder="Type (School / College / Group of Institutions)"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />

//         <input
//           name="no_of_people"
//           value={form.no_of_people}
//           onChange={handleChange}
//           placeholder="No. of Students + Staff Using the System"
//           required
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none md:col-span-2"
//         />
//       </div>

//       <button
//         type="submit"
//         disabled={submitting}
//         className="bg-blue-600 hover:bg-blue-700 transition px-6 py-3 rounded-full font-semibold w-full mt-6 disabled:opacity-50"
//       >
//         {submitting ? 'Submitting...' : 'Submit'}
//       </button>

//       {status && (
//         <p
//           role="status"
//           className={`text-center mt-4 text-sm ${
//             status.type === 'success' ? 'text-green-400' : 'text-red-400'
//           }`}
//         >
//           {status.msg}
//         </p>
//       )}

//       <p className="text-xs mt-4 text-white/60 text-center">
//         Your details will remain confidential and used only for enquiry purposes.
//       </p>
//     </form>
//   );
// };

// /* -------------------- MAIN PAGE ----------------------- */
// const SAMS = () => {
//   const [isLoading, setIsLoading] = useState(true);
//   const [showScroll, setShowScroll] = useState(false);
//   const [scrollProgress, setScrollProgress] = useState(0);

//   // 🔁 Ref for hero video
//   const heroVideoRef = useRef(null);

//   // Image load -> hide loading screen
//   useEffect(() => {
//     imagesLoaded(
//       document.querySelectorAll('.content__item-img'),
//       { background: true },
//       () => {
//         document.body.classList.remove('loading');
//         setIsLoading(false);
//       }
//     );
//   }, []);

//   // Parallax scroll for cards
//   useEffect(() => {
//     const items = document.querySelectorAll('.content__item');

//     const handleScroll = () => {
//       items.forEach((item) => {
//         const img = item.querySelector('.content__item-img');
//         const wrapper = img?.parentNode;
//         if (!img || !wrapper) return;

//         const rect = item.getBoundingClientRect();
//         const progress = Math.min(
//           Math.max((window.innerHeight - rect.top) / (window.innerHeight + rect.height), 0),
//           1
//         );

//         const translateY = progress * 100 - 50;
//         const rotate = progress * -45;

//         img.style.transform = `translateY(${translateY}px)`;
//         wrapper.style.transform = `rotate3d(1, 0.3, 0.1, ${rotate}deg)`;
//       });
//     };

//     window.addEventListener('scroll', handleScroll);
//     handleScroll();
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Circular scroll progress button visibility & progress
//   useEffect(() => {
//     const circumference = 307.919;
//     const handleProgress = () => {
//       const scrollTop = window.scrollY || document.documentElement.scrollTop;
//       const docHeight = document.documentElement.scrollHeight - window.innerHeight;
//       const progress = docHeight > 0 ? Math.min(Math.max(scrollTop / docHeight, 0), 1) : 0;
//       setScrollProgress(circumference * progress);
//       setShowScroll(scrollTop > 600);
//     };

//     window.addEventListener('scroll', handleProgress);
//     handleProgress();
//     return () => window.removeEventListener('scroll', handleProgress);
//   }, []);

//   // 🔁 Restart hero video when user scrolls back to top
//   useEffect(() => {
//     let wasNotAtTop = false;

//     const handleVideoReset = () => {
//       const scrollTop = window.scrollY || document.documentElement.scrollTop;
//       const isAtTop = scrollTop < 50;

//       // Only reset when going from not-top → top
//       if (isAtTop && wasNotAtTop && heroVideoRef.current) {
//         heroVideoRef.current.currentTime = 0;
//         heroVideoRef.current.play().catch(() => {});
//       }

//       wasNotAtTop = !isAtTop;
//     };

//     window.addEventListener('scroll', handleVideoReset);
//     handleVideoReset(); // initial check

//     return () => window.removeEventListener('scroll', handleVideoReset);
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });

//     // also restart video when using the scroll-to-top button
//     if (heroVideoRef.current) {
//       heroVideoRef.current.currentTime = 0;
//       heroVideoRef.current.play().catch(() => {});
//     }
//   };

//   return (
//     <>
//       <Helmet>
//         <title>School Administration Software | Smart &amp; Connected ERP</title>
//         <meta
//           name="description"
//           content="Simplify school operations with SecurXperts’ ERP—manage attendance, fees, transport, exams & communication in one secure, cloud-based platform."
//         />
//       </Helmet>

//       {/* Loading Screen */}
//       <div
//         className={`fixed inset-0 bg-black flex items-center justify-center z-50 transition-opacity duration-1000 ${
//           isLoading ? 'opacity-100' : 'opacity-0 pointer-events-none'
//         }`}
//       >
//         <h1 className="text-4xl md:text-6xl font-bold text-white animate-pulse text-center px-4">
//           SecurXperts School ERP
//         </h1>
//       </div>

//       {/* Navbar */}
//       <Navbar />

//       {/* Hero Video Section */}
//       <section className="relative h-screen">
//         <video
//           ref={heroVideoRef}
//           className="absolute inset-0 w-full h-full object-cover"
//           autoPlay
//           loop
//           muted
//           playsInline
//         >
//           <source src="/video/Vishan (1).mp4" type="video/mp4" />
//         </video>
//         <div className="absolute inset-0 bg-black/60" />
//       </section>

//       {/* Main Content with Parallax */}
//       <main className="bg-black text-white">
//         <div className="content content--padded">
//           {/* Key Features Section */}
//           <section className="py-12 max-w-5xl mx-auto text-left px-6">
//             <h2 className="text-3xl md:text-4xl font-extrabold mb-6">
//               Key Features of SecurXperts School Administration Software
//             </h2>

//             {/* 1) Student Attendance Management */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 1) Student Attendance Management
//               </h3>
//               <p className="text-base md:text-lg">
//                 Digitally track student attendance and instantly notify parents, ensuring precise and
//                 transparent records.
//               </p>
//             </div>

//             {/* 2) Teacher & Classroom Management */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 2) Teacher &amp; Classroom Management
//               </h3>
//               <p className="text-base md:text-lg">
//                 Teachers can schedule classes, assign lessons, share homework and track performance—all in one
//                 simple platform.
//               </p>
//             </div>

//             {/* 3) Transport Management */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 3) Transport Management
//               </h3>
//               <p className="text-base md:text-lg">
//                 GPS-enabled bus tracking ensures safe travel, with real-time route updates and alerts for
//                 parents and school admins.
//               </p>
//             </div>

//             {/* 4) Accounts & Payroll Management */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 4) Accounts &amp; Payroll Management
//               </h3>
//               <p className="text-base md:text-lg">
//                 Automate fee collection, payroll, and expenses with secure online payments, reminders and
//                 audit-ready reports.
//               </p>
//             </div>

//             {/* 5) Student Progress & Reports */}
//             <div className="mb-8">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 5) Student Progress &amp; Reports
//               </h3>
//               <p className="text-base md:text-lg">
//                 Plan exams, generate digital report cards, and analyse performance trends to identify and
//                 address learning gaps.
//               </p>
//             </div>

//             {/* 6) Library Management */}
//             <div className="mb-2">
//               <h3 className="text-2xl md:text-3xl font-bold mb-3">
//                 6) Library Management
//               </h3>
//               <p className="text-base md:text-lg">
//                 Easily manage book issues, returns, and fines with barcode/RFID systems, plus provide access to
//                 digital resources.
//               </p>
//             </div>
//           </section>

//           {/* Parallax Cards – School ERP visuals */}
//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/school-attendance.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Real-Time Attendance & Alerts</h2>
//             <p className="content__item-description">
//               Track in-class and bus attendance in real-time, with instant messages to parents for absences or
//               late arrivals.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/school-teachers.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Teacher & Lesson Planning Hub</h2>
//             <p className="content__item-description">
//               Give teachers a single dashboard for lesson plans, homework assignment, grading and student
//               feedback.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/school-transport.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Safe & Transparent Transport</h2>
//             <p className="content__item-description">
//               GPS-based tracking with live route status, pickup/drop alerts and fleet analytics for
//               administrators.
//             </p>
//           </div>

//           <div
//             className="content__item content__item--expand"
//             style={{ ['--aspect-ratio']: '7/5' }}
//           >
//             <div className="content__item-imgwrap">
//               <div
//                 className="content__item-img"
//                 style={{ backgroundImage: "url('/img/school-reports.jpg')" }}
//               />
//             </div>
//             <h2 className="content__item-title">Digital Reports & Analytics</h2>
//             <p className="content__item-description">
//               Monitor academic performance, fee collection, attendance and more through smart visual dashboards.
//             </p>
//           </div>

//           {/* CTA */}
//           <section className="text-center py-32">
//             <h2 className="text-4xl md:text-7xl font-bold mb-10">
//               Ready to Modernise Your School Operations?
//             </h2>
//             <div className="space-x-8">
//               <Link
//                 to="/get-quoted"
//                 className="inline-block bg-blue-600 text-white px-10 py-5 rounded-full text-2xl font-bold hover:bg-blue-700 transition transform hover:scale-110"
//               >
//                 Book School ERP Demo
//               </Link>
//               <Link
//                 to="/contact-us"
//                 className="inline-block bg-white text-blue-600 px-10 py-5 rounded-full text-2xl font-bold hover:bg-gray-100 transition transform hover:scale-110"
//               >
//                 Talk to Our Team
//               </Link>
//             </div>
//           </section>

//           {/* Contact section */}
//           <section id="contact" className="py-16 bg-gradient-to-b from-black to-gray-900">
//             <div className="max-w-6xl mx-auto px-6">
//               <h3 className="text-3xl md:text-4xl font-extrabold text-center mb-6">
//                 Get in touch
//               </h3>
//               <p className="text-center text-white/70 mb-8">
//                 Want to digitise your school or group of institutions? Share your details and we’ll schedule a
//                 personalised School ERP demo.
//               </p>

//               <ContactForm />
//             </div>
//           </section>
//         </div>
//       </main>

//       {/* Footer */}
//       <Footer />

//       {/* Scroll to Top Button (arrow) */}
//       <button
//         onClick={scrollToTop}
//         className="scrollToTopBtn fixed bottom-10 right-10 z-50 opacity-0 transition-all duration-700"
//       >
//         <svg className="w-16 h-16 text-white drop-shadow-2xl" viewBox="0 0 512 512">
//           <path fill="currentColor" d="M256 108L109 296l37 37 90-90v210h48V243l90 90 37-37z" />
//         </svg>
//       </button>

//       {/* Circular Scroll Progress Button */}
//       {showScroll && (
//         <div
//           onClick={scrollToTop}
//           className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 shadow-lg hover:from-blue-600 hover:to-blue-800 transition-all"
//         >
//           <svg className="progress-circle -rotate-90 w-12 h-12 absolute" viewBox="-1 -1 102 102">
//             <path
//               d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
//               fill="none"
//               stroke="white"
//               strokeWidth="4"
//               strokeDasharray="307.919"
//               strokeDashoffset={307.919 - scrollProgress}
//               style={{ transition: 'stroke-dashoffset 0.1s linear' }}
//             />
//           </svg>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="w-6 h-6 text-white relative z-10"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//             strokeWidth={2}
//           >
//             <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
//           </svg>
//         </div>
//       )}
//     </>
//   );
// };

// export default SAMS;




// import React, { useState } from "react";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";

// /* -------------------- CONTACT FORM (MERGED EXACTLY AS REQUESTED) ----------------------- */
// const API_URL = 'https://api.securxperts.com:8000';
// const ENDPOINT = '/forms/sams';

// const ContactForm = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     country_code: "",
//     phoneno: "",
//     location: "",
//     no_of_branches: "",
//     industry_type: "",
//     no_of_people: "",
//   });

//   const [submitting, setSubmitting] = useState(false);
//   const [status, setStatus] = useState(null);

//   const handleChange = (e) =>
//     setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

//   const validate = () => {
//     if (!form.name.trim()) return "Name is required";
//     if (!form.email.trim()) return "Email is required";
//     const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRe.test(form.email)) return "Enter a valid email";
//     if (!form.country_code.trim()) return "Country code is required";
//     if (!form.phoneno.trim()) return "Phone number is required";
//     if (!form.location.trim()) return "Location is required";
//     if (!form.no_of_branches.trim()) return "Number of branches is required";
//     if (!form.industry_type.trim()) return "Industry type is required";
//     if (!form.no_of_people.trim()) return "Number of people is required";
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus(null);

//     const err = validate();
//     if (err) {
//       setStatus({ type: "error", msg: err });
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const resp = await fetch(`${API_URL}${ENDPOINT}`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });

//       if (resp.ok) {
//         let data;
//         try {
//           data = await resp.json();
//         } catch {}
//         setStatus({
//           type: "success",
//           msg:  "Thank you! Your request has been submitted.",
//         });
//         setForm({
//           name: "",
//           email: "",
//           country_code: "",
//           phoneno: "",
//           location: "",
//           no_of_branches: "",
//           industry_type: "",
//           no_of_people: "",
//         });
//       } else {
//         let errText = `Server responded with ${resp.status}`;
//         try {
//           const json = await resp.json();
//           if (json?.error) errText = json.error;
//           else if (json?.message) errText = json.message;
//         } catch {
//           const txt = await resp.text().catch(() => null);
//           if (txt) errText = txt;
//         }
//         setStatus({ type: "error", msg: `Submission failed: ${errText}` });
//       }
//     } catch (error) {
//       setStatus({ type: "error", msg: "Network error. Please try again." });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//    <form
//   onSubmit={handleSubmit}
//   className="max-w-3xl mx-auto bg-white p-6 md:p-10 rounded-2xl shadow-xl border border-gray-200"
// >
//   <h3 className="text-3xl font-bold text-center mb-8 text-[#0a66c2]">
//     School ERP Enquiry Form
//   </h3>

//   <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//     <input
//       name="name"
//       value={form.name}
//       onChange={handleChange}
//       placeholder="Full Name"
//       required
//      className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-white
//            text-gray-800 placeholder-gray-400
//            focus:outline-none focus:border-[#0a66c2]
//            focus:ring-1 focus:ring-[#0a66c2]/30
//            transition-all duration-200"

//     />

//     <input
//       name="email"
//       type="email"
//       value={form.email}
//       onChange={handleChange}
//       placeholder="Email"
//       required
//       className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-white
//            text-gray-800 placeholder-gray-400
//            focus:outline-none focus:border-[#0a66c2]
//            focus:ring-1 focus:ring-[#0a66c2]/30
//            transition-all duration-200"

//     />

//     <input
//       name="country_code"
//       value={form.country_code}
//       onChange={handleChange}
//       placeholder="Country Code"
//       required
//       className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-white
//            text-gray-800 placeholder-gray-400
//            focus:outline-none focus:border-[#0a66c2]
//            focus:ring-1 focus:ring-[#0a66c2]/30
//            transition-all duration-200"

//     />

//     <input
//       name="phoneno"
//       value={form.phoneno}
//       onChange={handleChange}
//       placeholder="Phone Number"
//       required
//       className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-white
//            text-gray-800 placeholder-gray-400
//            focus:outline-none focus:border-[#0a66c2]
//            focus:ring-1 focus:ring-[#0a66c2]/30
//            transition-all duration-200"

//     />

//     <input
//       name="location"
//       value={form.location}
//       onChange={handleChange}
//       placeholder="School Location"
//       required
//      className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-white
//            text-gray-800 placeholder-gray-400
//            focus:outline-none focus:border-[#0a66c2]
//            focus:ring-1 focus:ring-[#0a66c2]/30
//            transition-all duration-200"

//     />

//     <input
//       name="no_of_branches"
//       value={form.no_of_branches}
//       onChange={handleChange}
//       placeholder="No. of Branches"
//       required
//       className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-white
//            text-gray-800 placeholder-gray-400
//            focus:outline-none focus:border-[#0a66c2]
//            focus:ring-1 focus:ring-[#0a66c2]/30
//            transition-all duration-200"

//     />

//     <input
//       name="industry_type"
//       value={form.industry_type}
//       onChange={handleChange}
//       placeholder="Type (School / College)"
//       required
//       className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-white
//            text-gray-800 placeholder-gray-400
//            focus:outline-none focus:border-[#0a66c2]
//            focus:ring-1 focus:ring-[#0a66c2]/30
//            transition-all duration-200"

//     />

//     <input
//       name="no_of_people"
//       value={form.no_of_people}
//       onChange={handleChange}
//       placeholder="No. of Users"
//       required
//       className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-white
//            text-gray-800 placeholder-gray-400
//            focus:outline-none focus:border-[#0a66c2]
//            focus:ring-1 focus:ring-[#0a66c2]/30
//            transition-all duration-200"

//     />
//   </div>

//   <button
//     type="submit"
//     disabled={submitting}
//     className="w-full bg-[#0a66c2] hover:bg-[#084c93] text-white py-3 rounded-xl font-semibold mt-8 shadow-md transition-all duration-300"
//   >
//     {submitting ? "Submitting..." : "Submit Enquiry"}
//   </button>

//   {status && (
//     <p
//       className={`mt-4 text-center text-sm font-medium ${
//         status.type === "success" ? "text-green-600" : "text-red-600"
//       }`}
//     >
//       {status.msg}
//     </p>
//   )}
// </form>

//   );
// };
// export default function Sams() {
//   return (
//     <div className="w-full font-sans text-[126, 202, 242] overflow-hidden">
// <Navbar/>
//       {/* ================= HERO SECTION ================= */}
//       <section className="relative w-full bg-[#9999] text-white px-6 md:px-16 py-20">
//  {/* Logo Placeholder */}
//   {/* <div className="absolute top-10 left-6 md:top-5 md:left-16 z-20 w-12 h-12">
//     <img
//       src="/img/vishan.png"   // <-- Replace with your logo file
//       alt="aroganarayan logo"
//       className="w-32 md:w-40 object-contain"
//     />
//   </div> */}
//         <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center">
//           {/* Left Section */}
//           <div>
//              <img
//               src="/img/62.png" 
//             alt="Logo"
//             className="w-32 mb-6"
//           />
//             <h1 className="text-4xl md:text-5xl font-bold leading-tight">
//               School Management Software for Modern Campuses

//             </h1>

//             <p className="mt-4 text-lg text-white/90">
//               An AI-enabled school administration ERP designed to simplify academic operations, strengthen communication and enhance campus-wide management. Manage every school function efficiently and securely through a powerful, cloud-based system.

//             </p>

           
//           </div>

//           {/* Right Image Placeholder */}
//           <div className="flex justify-center">
//             <img
//               src="/img/samsheroimg.png"
//               alt="Student"
//               className="w-100 md:w-96 rounded-xl mt-32"
//             />
//           </div>
//         </div>
//       </section>

//       {/* ================= VIDEO SECTION ================= */}
//         {/* FULL-WIDTH VIDEO SECTION – LOOP + CLICK PAUSE/PLAY + RESTART ON REFRESH */}
// <section className="w-full py-20 px-6 md:px-0 bg-gray-50">
//   <div className="max-w-7xl mx-auto">
 
//     <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl group">
//       <video
//         className="w-full block"
//         src="/video/vishan.mp4"
//         muted                    // Required for autoplay
//         playsInline
//         autoPlay                 // Starts immediately
//         loop                     // Plays continuously forever
//         preload="auto"
//         controls={false}         // No control bar
//         // Restart from beginning every time page loads/refreshes
//         key="lauratek-video"    
//         // Click = Pause / Play
//         onClick={(e) => {
//           const video = e.currentTarget;
//           video.paused ? video.play() : video.pause();
//         }}
//       >
//         Your browser does not support HTML5 video.
//       </video>
 
//       {/* ONLY Fullscreen Button – appears on hover */}
//       <div className="absolute bottom-6 right-6 md:bottom-8 md:right-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
//         <button
//           onClick={(e) => {
//             e.stopPropagation();
//             const video = e.currentTarget.closest('div').querySelector('video');
//             if (video.requestFullscreen) video.requestFullscreen();
//             else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
//             else if (video.mozRequestFullScreen) video.mozRequestFullScreen();
//             else if (video.msRequestFullscreen) video.msRequestFullscreen();
//           }}
//           className="bg-black/70 hover:bg-black/90 text-white p-4 rounded-xl backdrop-blur-md transition transform hover:scale-110 shadow-2xl"
//           title="Fullscreen"
//         >
//           <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
//               d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4-4l-5-5" />
//           </svg>
//         </button>
//       </div>
 
//       {/* Optional: Subtle pulsing play icon in center */}
//       {/* <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
//         <div className="animate-pulse">
//           <div className="w-20 h-20 bg-white/20 backdrop-blur rounded-full flex items-center justify-center">
//             <svg className="w-10 h-10 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
//               <path d="M8 5v14l11-7z"/>
//             </svg>
//           </div>
//         </div>
//       </div> */}
//     </div>
 
//   </div>
// </section>

//       {/* ================= FEATURES SECTION ================= */}
//       <section className="w-full px-6 md:px-16 py-20 bg-[#f7faff]">
//   <div className="max-w-6xl mx-auto text-center">
//     <h2 className="text-3xl font-bold mb-10">
//       Why Schools Prefer Our Management Software
//     </h2>

//     <div className="grid md:grid-cols-4 gap-6">

//       {/* 1 */}
//       <div className="bg-white p-6 rounded-xl shadow transition-all duration-300 
//                       hover:bg-[#0a66c2] cursor-pointer hover:shadow-lg">
//         <img src="/img/fullyautomated.png" alt="Library" className="w-14 mb-4" />
//         <h3 className="text-xl font-semibold mb-2">
//           Fully Automated School Operations
//         </h3>
//         <p className="text-gray-600 text-sm">
//           Automate academic, administrative, and financial tasks to boost productivity
//         </p>
//       </div>

//       {/* 2 */}
//       <div className="bg-white p-6 rounded-xl shadow transition-all duration-300 
//                       hover:bg-[#0a66c2] cursor-pointer hover:shadow-lg">
//         <img src="/img/userfriendly.png" alt="Instructors" className="w-14 mb-4" />
//         <h3 className="text-xl font-semibold mb-2">
//           User-Friendly & Intuitive Design
//         </h3>
//         <p className="text-gray-600 text-sm">
//           Clean, structured interface ensures easy navigation for teachers, staff & students
//         </p>
//       </div>

//       {/* 3 */}
//       <div className="bg-white p-6 rounded-xl shadow transition-all duration-300 
//                       hover:bg-[#0a66c2] cursor-pointer hover:shadow-lg">
//         <img src="/img/accessible.png" alt="Training" className="w-14 mb-4" />
//         <h3 className="text-xl font-semibold mb-2">
//           Accessible on Any Device
//         </h3>
//         <p className="text-gray-600 text-sm">
//           Track attendance, homework, fees and reports anytime on any device
//         </p>
//       </div>

//       {/* 4 */}
//       <div className="bg-white p-6 rounded-xl shadow transition-all duration-300 
//                       hover:bg-[#0a66c2] cursor-pointer hover:shadow-lg">
//         <img src="/img/fitsschools.png" alt="Class" className="w-14 mb-4" />
//         <h3 className="text-xl font-semibold mb-2">
//           Fits Schools of Every Size
//         </h3>
//         <p className="text-gray-600 text-sm">
//           The platform adapts to your school’s structure and growth seamlessly
//         </p>
//       </div>

//     </div>
//   </div>
// </section>


//       {/* ================= APP SECTION ================= */}
//       <section className="w-full px-6 md:px-16 py-20 bg-white">
//         <div className="max-w-6xl mx-auto">

//           <h2 className="text-3xl font-bold">
//             Core Capabilities of Our School Management Software
//           </h2>

         

//           <div className="grid md:grid-cols-2 gap-10 mt-12">
//             <img
//               src="/img/sams1.png"
//               alt="App"
//               className="rounded-xl shadow-lg"
//             />

//             <div className="grid gap-6">

//               <div className="p-6 bg-[#f7faff] rounded-xl shadow">
//                 <h3 className="text-xl font-semibold mb-2">Streamlined Academic & Administrative Workflows
// </h3>
//                 {/* <p className="text-gray-600 text-sm">
//                   Clean and intuitive interface for teachers and students.
//                 </p> */}
//               </div>

//               <div className="p-6 bg-[#f7faff] rounded-xl shadow">
//                 <h3 className="text-xl font-semibold mb-2">Complete Student Lifecycle Management</h3>
//                 {/* <p className="text-gray-600 text-sm">
//                   Get instant updates on attendance, fees, and notifications.
//                 </p> */}
//               </div>

//               <div className="p-6 bg-[#f7faff] rounded-xl shadow">
//                 <h3 className="text-xl font-semibold mb-2">All Essential Modules in One System
// </h3>
//                 {/* <p className="text-gray-600 text-sm">
//                   Encrypted cloud-based data protection system.
//                 </p> */}
//               </div>

//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ================= FOOTER SECTION ================= */}
//       {/* <section className="w-full bg-[#1f2a37] text-white py-20 px-6 md:px-16">
//         <div className="max-w-6xl mx-auto text-center">

//           <h2 className="text-3xl font-bold mb-6">Be incredible</h2>
//           <p className="text-gray-300 max-w-xl mx-auto mb-10">
//             Discover a new level of efficiency with our school management software.
//           </p>

//           <button className="bg-[#0a66c2] px-8 py-3 rounded-lg font-semibold">
//             Explore it Today
//           </button>

//           <div className="grid md:grid-cols-3 gap-6 mt-14">

//             <img src="/img/footer-1.png" className="rounded-xl shadow" alt="" />
//             <img src="/img/footer-2.png" className="rounded-xl shadow" alt="" />
//             <img src="/img/footer-3.png" className="rounded-xl shadow" alt="" />

//           </div>
//         </div>
//       </section> */}
//        <section className="w-full px-6 md:px-16 py-20 bg-gray-50">
//         <div className="max-w-6xl mx-auto">
//           <h2 className="text-3xl font-bold text-center mb-4">Get in Touch</h2>
//           <p className="text-center text-gray-600 mb-10">
//             Fill out the form below and our School ERP experts will contact you.
//           </p>

//           <ContactForm />
//         </div>
//       </section>
// <Footer/>
//     </div>
//   );
// }





import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

/* -------------------- CONTACT FORM (UPDATED WITH REAL-TIME VALIDATION) ----------------------- */
const API_URL = 'https://api.securxperts.com:8000';
const ENDPOINT = '/forms/sams';

const SuccessPopup = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl px-10 py-8 max-w-md w-full text-center shadow-2xl relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-xl"
        >
          ×
        </button>

        <h3 className="text-green-600 text-2xl font-semibold mb-3">
          Success
        </h3>

        <p className="text-gray-600 text-base">
          Your request has been submitted successfully.
        </p>
      </div>
    </div>
  );
};


const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    country_code: "",
    phoneno: "",
    location: "",
    no_of_branches: "",
    industry_type: "",
    no_of_people: "",
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let filteredValue = value;

    if (name === 'name') {
      filteredValue = value.replace(/[^A-Za-z\s]/g, '');
    } else if (name === 'phoneno' || name === 'no_of_people' || name === 'no_of_branches') {
      filteredValue = value.replace(/[^0-9]/g, '');
    } else if (name === 'country_code') {
      filteredValue = value.replace(/[^+0-9]/g, '');
    }

    setForm((prev) => ({ ...prev, [name]: filteredValue }));
    setErrors((prev) => ({ ...prev, [name]: validateField(name, filteredValue) }));
  };

  const validateField = (name, value) => {
    switch (name) {
      case 'name':
        if (!value.trim()) return 'Please enter full name';
        return '';
      case 'email':
        if (!value.trim()) return 'Email is required';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Invalid email';
        return '';
      case 'country_code':
        if (!value.trim()) return 'Country code is required';
        return '';
      case 'phoneno':
        if (!value.trim()) return 'Phone number is required';
        return '';
      case 'location':
        return !value.trim() ? 'Please enter school location' : '';
      case 'industry_type':
        return !value.trim() ? 'Please specify type' : '';
      case 'no_of_people':
      case 'no_of_branches':
        return !value.trim() ? 'This field is required' : '';
      default:
        return '';
    }
  };

  const validateAll = () => {
    const newErrors = {};
    Object.keys(form).forEach((key) => {
      newErrors[key] = validateField(key, form[key]);
    });
    setErrors(newErrors);
    return Object.values(newErrors).every((e) => e === '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    if (!validateAll()) {
      setStatus({ type: "error", msg: "Please correct the errors shown above" });
      return;
    }

    setSubmitting(true);
    try {
      const resp = await fetch(`${API_URL}${ENDPOINT}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (resp.ok) {
        setShowSuccessPopup(true);
        setForm({
          name: "",
          email: "",
          country_code: "",
          phoneno: "",
          location: "",
          no_of_branches: "",
          industry_type: "",
          no_of_people: "",
        });
        setErrors({});
      } else {
        setStatus({ type: "error", msg: "Submission failed" });
      }
    } catch {
      setStatus({ type: "error", msg: "Network error" });
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (showSuccessPopup) {
      const t = setTimeout(() => setShowSuccessPopup(false), 5000);
      return () => clearTimeout(t);
    }
  }, [showSuccessPopup]);


  
  

  return (
      <>
    <SuccessPopup
      show={showSuccessPopup}
      onClose={() => setShowSuccessPopup(false)}
    />
    <form
      onSubmit={handleSubmit}
      className="max-w-3xl mx-auto bg-white p-6 md:p-10 rounded-2xl shadow-xl border"
    >
      <h3 className="text-3xl font-bold text-center mb-8 text-[#0a66c2]">
        School ERP Enquiry Form
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <input name="name" value={form.name} onChange={handleChange} placeholder="Full Name" className="w-full px-4 py-3 border rounded-xl" />
        <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email" className="w-full px-4 py-3 border rounded-xl" />

        {/* ✅ COUNTRY CODE DROPDOWN */}
        <select
          name="country_code"
          value={form.country_code}
          onChange={handleChange}
          className="w-full px-4 py-3 border rounded-xl bg-white"
        >
          <option value="">Select Country Code</option>
          <option value="+91">🇮🇳 +91</option>
          <option value="+1">🇺🇸 +1</option>
          <option value="+44">🇬🇧 +44</option>
          <option value="+61">🇦🇺 +61</option>
          <option value="+971">🇦🇪 +971</option>
        </select>

        <input name="phoneno" value={form.phoneno} onChange={handleChange} placeholder="Phone Number" className="w-full px-4 py-3 border rounded-xl" />
        <input name="location" value={form.location} onChange={handleChange} placeholder="School Location" className="w-full px-4 py-3 border rounded-xl" />
        <input name="no_of_branches" value={form.no_of_branches} onChange={handleChange} placeholder="No. of Branches" className="w-full px-4 py-3 border rounded-xl" />
        <input name="industry_type" value={form.industry_type} onChange={handleChange} placeholder="Type (School / College)" className="w-full px-4 py-3 border rounded-xl" />
        <input name="no_of_people" value={form.no_of_people} onChange={handleChange} placeholder="No. of Users" className="w-full px-4 py-3 border rounded-xl" />
      </div>

      <button
        type="submit"
        disabled={submitting}
        className="w-full bg-[#0a66c2] text-white py-3 rounded-xl mt-8"
      >
        {submitting ? "Submitting..." : "Submit Enquiry"}
      </button>
    </form>
      </>

  );
};

export default function Sams() {
  return (
    <div className="w-full font-sans text-[126, 202, 242] overflow-hidden">
    <div className="fixed top-0 left-0 w-full z-[9999]">
  <Navbar />
</div>


      {/* ================= HERO SECTION ================= */}
      <section className="relative w-full bg-[#9999] text-white px-6 md:px-16 py-20">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center">
          {/* Left Section */}
          <div>
            <img
              src="/img/62.png"
              alt="Logo"
              className="w-32 mb-6"
            />
            <h1 className="text-4xl md:text-5xl font-bold leading-tight">
              School Management Software for Modern Campuses
            </h1>

            <p className="mt-4 text-lg text-white/90">
              An AI-enabled school administration ERP designed to simplify academic operations, strengthen communication and enhance campus-wide management. Manage every school function efficiently and securely through a powerful, cloud-based system.
            </p>
          </div>

          {/* Right Image */}
          <div className="flex justify-center">
            <img
              src="/img/samsheroimg.png"
              alt="Student"
              className="w-100 md:w-96 rounded-xl mt-32"
            />
          </div>
        </div>
      </section>

      {/* ================= VIDEO SECTION ================= */}
      <section className="w-full py-20 px-6 md:px-0 bg-gray-50">
        <div className="max-w-7xl mx-auto">
           <div className="max-w-3xl mx-auto mb-10 text-center">
    <h2 className="text-3xl font-bold text-[#063852]">
             Explore School Management Live
            </h2>
            <p className="text-gray-600 mt-3">
             See how our software makes school operations simple and efficient—handling everything from student records to staff co-ordination on one smart, digital platform.
            </p>
            </div>
 
          <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl group">
            <video
              className="w-full block"
              src="/video/vishan.mp4"
              muted
              playsInline
              autoPlay
              loop
              preload="auto"
              controls={false}
              key="lauratek-video"
              onClick={(e) => {
                const video = e.currentTarget;
                video.paused ? video.play() : video.pause();
              }}
            >
              Your browser does not support HTML5 video.
            </video>

            <div className="absolute bottom-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  const video = e.currentTarget.closest('div').querySelector('video');
                  if (video.requestFullscreen) video.requestFullscreen();
                }}
                className="bg-black/70 hover:bg-black/90 text-white p-4 rounded-xl backdrop-blur-md transition transform hover:scale-110 shadow-2xl"
                title="Fullscreen"
              >
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4-4l-5-5" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FEATURES SECTION ================= */}
      <section className="w-full px-6 md:px-16 py-20 bg-[#f7faff]">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-10">
            Why Schools Prefer Our Management Software
          </h2>

          <div className="grid md:grid-cols-4 gap-6">
            {/* 1 */}
            <div className="bg-white p-6 rounded-xl shadow transition-all duration-300 hover:bg-[#0a66c2] cursor-pointer hover:shadow-lg">
              <img src="/img/fullyautomated.png" alt="Library" className="w-14 mb-4" />
              <h3 className="text-xl font-semibold mb-2">
                Fully Automated School Operations
              </h3>
              <p className="text-gray-600 text-sm">
                Automate academic, administrative, and financial tasks to boost productivity
              </p>
            </div>

            {/* 2 */}
            <div className="bg-white p-6 rounded-xl shadow transition-all duration-300 hover:bg-[#0a66c2] cursor-pointer hover:shadow-lg">
              <img src="/img/userfriendly.png" alt="Instructors" className="w-14 mb-4" />
              <h3 className="text-xl font-semibold mb-2">
                User-Friendly & Intuitive Design
              </h3>
              <p className="text-gray-600 text-sm">
                Clean, structured interface ensures easy navigation for teachers, staff & students
              </p>
            </div>

            {/* 3 */}
            <div className="bg-white p-6 rounded-xl shadow transition-all duration-300 hover:bg-[#0a66c2] cursor-pointer hover:shadow-lg">
              <img src="/img/accessible.png" alt="Training" className="w-14 mb-4" />
              <h3 className="text-xl font-semibold mb-2">
                Accessible on Any Device
              </h3>
              <p className="text-gray-600 text-sm">
                Track attendance, homework, fees and reports anytime on any device
              </p>
            </div>

            {/* 4 */}
            <div className="bg-white p-6 rounded-xl shadow transition-all duration-300 hover:bg-[#0a66c2] cursor-pointer hover:shadow-lg">
              <img src="/img/fitsschools.png" alt="Class" className="w-14 mb-4" />
              <h3 className="text-xl font-semibold mb-2">
                Fits Schools of Every Size
              </h3>
              <p className="text-gray-600 text-sm">
                The platform adapts to your school’s structure and growth seamlessly
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= APP SECTION ================= */}
      <section className="w-full px-6 md:px-16 py-20 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold">
            Core Capabilities of Our School Management Software
          </h2>

          <div className="grid md:grid-cols-2 gap-10 mt-12">
            <img
              src="/img/sams1.png"
              alt="App"
              className="rounded-xl shadow-lg"
            />

            <div className="grid gap-6">
              <div className="p-6 bg-[#f7faff] rounded-xl shadow">
                <h3 className="text-xl font-semibold mb-2">Streamlined Academic & Administrative Workflows</h3>
              </div>

              <div className="p-6 bg-[#f7faff] rounded-xl shadow">
                <h3 className="text-xl font-semibold mb-2">Complete Student Lifecycle Management</h3>
              </div>

              <div className="p-6 bg-[#f7faff] rounded-xl shadow">
                <h3 className="text-xl font-semibold mb-2">All Essential Modules in One System</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= GET IN TOUCH SECTION ================= */}
      <section className="w-full px-6 md:px-16 py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-4">Get in Touch</h2>
          <p className="text-center text-gray-600 mb-10">
            Fill out the form below and our School ERP experts will contact you.
          </p>

          <ContactForm />
        </div>
      </section>

      <Footer />
    </div>
  );
}